<template>
    <div>
        <div v-for="(branch, index) of tree" :key="'tree-view_level-' + level + '_branch-' + index">
            <div v-if="branch.children && branch.children.length">
                <slot
                    name="branch"
                    v-bind="{ item: branch.item, level, name: branch.name, id: branch.id }"
                />
                <div class="pl-3">
                    <TreeView
                        :items="branch.children"
                        :branchClick="branchClick"
                        :level="level + 1"
                    >
                        <template #branch="{ item, level, name, id }">
                            <slot name="branch" v-bind="{ item, level, name, id }" />
                        </template>
                        <template #leaf="{ item, level, name, id }">
                            <slot name="leaf" v-bind="{ item, level, name, id }" />
                        </template>
                    </TreeView>
                </div>
            </div>
            <div v-else>
                <slot
                    name="leaf"
                    v-bind="{ item: branch.item, level, name: branch.name, id: branch.id }"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class TreeView extends Vue {
    @Prop() items!: Item[];
    @Prop({ default: false }) branchClick!: boolean;
    @Prop({ default: 0 }) level!: number;

    @Prop() className: string;

    get tree(): Branch[] {
        const branches: Branch[] = [];
        for (const item of this.items) {
            const path = item.name.split("/");
            let branch = branches.find((branch) => branch.name === path[0]);
            if (!branch) {
                branch = {
                    id: item.id,
                    name: path[0],
                    children: [],
                    item,
                };
                branches.push(branch);
            }
            if (path.length > 1) {
                branch.children.push({
                    id: item.id,
                    name: path.slice(1).join("/"),
                    item,
                });
            }
        }
        // console.log("branches", branches);
        return branches;
    }
}

type Branch = {
    id: number;
    name: string;
    item?: Item;
    children?: Item[];
};

type Item = {
    id: number;
    name: string; // folderName1/folderName2/.../fileName
} & { [key: string]: any };

export default toNative(TreeView);
</script>
